import { Suspense } from "react";

import { useDialog } from "~/src/modules/ui-kit";

import MaterialDetail from "./MaterialDetail";
import MaterialCard from "../../entities/material/MaterialCard";


export default function Layer(props) {
    const { onChange, onRemove, ...materialProps } = props;

    const [Dialog, open, close] = useDialog();

    return (
        <Suspense>
            <MaterialCard
                { ...materialProps }
                onEdit={ open }
                onRemove={ onRemove }
            />
            <Dialog>
                <MaterialDetail
                    { ...materialProps }
                    onChange={ onChange }
                    onClose={ close }
                />
            </Dialog>
        </Suspense>
    );
}
